import type { Cookies } from 'types/cookies';
import { WEBVIEW_AMETHYST_SESSION_ID } from 'constants/cookies';

/*
  Takes cookie object(like state.cookies) and returns it into a cookie string that could be used for Cookie headers
  Example param: {at-main: '123'};
  Example return: 'at-main=123;';
*/
export const cookieObjectToString = (obj: { [x: string]: string } = {}) =>
  Object.keys(obj)
    .map(v => obj[v] && `${v}=${obj[v]}; `)
    .join('')
    .trim();

/**
 * The mobile apps (iOS/Android) set the `webview-amethyst-session-id` cookie on
 * `.zappos.com` before loading a page inside a WebView. Use this to detect
 * WebView traffic so we can suppress web-only UI (e.g. the TrustArc cookie
 * consent banner) that the apps already handle at the OS level.
 */
export const isWebViewRequest = (cookies?: Cookies): boolean => !!cookies?.[WEBVIEW_AMETHYST_SESSION_ID];
